module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Cuisinart-26f55633b9037b3a1f9d92c6d3e1ad57.png";